import { ReduxStore } from "../../reducers/root_reducer";

const getElementSelection = (state: ReduxStore, props) => state.elementSelection;

export default getElementSelection;
